<template>
    <div v-if="loaded">
        <div class="topbar">
            <div class="topbar__inner">
                <ul class="topbar__side">

                </ul>
            </div>
        </div>

        <main class="main main--details">
            <aside class="aside aside--details">
                <div class="aside__inner">
                    <div class="image-block image-block--lg">
                        <img :src="logoUrl" alt="img"/>
                    </div>
                    <h2 class="heading2">{{commonData.name}}</h2>

                    <div v-if="false" class="type-label">Buzzing</div>
                    
                    <div class="aside--details__description mt-3">
                        <span class="ecosystem-label">Ecosystem</span>
                        <p>{{ commonData.short_description }} <a v-if="commonData.short_description != commonData.description" id="show-description" class="link">(more)</a></p>
                    </div>

                    <b-popover v-if="commonData.short_description != commonData.description" ref="descriptionPopover" target="show-description">
                        <div class="popover__content" v-click-outside="closeDescriptionPopover">
                            {{commonData.description}}
                        </div>
                    </b-popover>
                    
                    <h4 class="heading4 heading4--tertiary">
                        Overview
                        <a v-if="false" class="heading-edit"></a>
                    </h4>

                    <ul class="overview-list">
                        <li v-if="commonData.url_domain.length">
                            <a :href="'http://' + commonData.url_domain" target="_blank">
                                <font-awesome-icon :icon="['fa', 'globe']" />
                                {{ commonData.url_domain }}
                            </a>
                        </li>
                        <li v-if="commonData.total_raised > 0">
                            <span class="d-flex align-items-center"><span class="overview-list__icon icon-funding"></span>$ {{stringHelper.formatNumber(commonData.total_raised)}}</span>
                        </li>
                        <li v-if="commonData.revenue_range"><span class="overview-list__icon icon-income"></span> {{ commonData.revenue_range }} Annual Income</li>
                        <li v-if="false && commonData.employees"><font-awesome-icon :icon="['fa', 'users']" />{{ commonData.employees }} Employees</li>
                        <li><font-awesome-icon :icon="['fa', 'map-marker-alt']" /> {{ location }}</li>
                        <li v-if="commonData.founded"><span class="overview-list__icon icon-founded"></span> Founded {{ commonData.founded }}</li>
                    </ul>
                    
                    <ul class="social-list">
                        <li v-if="commonData.linkedin_url">
                            <a :href="commonData.linkedin_url">
                                <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                            </a>
                        </li>
                        <li v-if="commonData.twitter_url">
                            <a :href="commonData.twitter_url">
                                <font-awesome-icon :icon="['fab', 'twitter']" />
                            </a>
                        </li>
                        <li v-if="commonData.facebook_url">
                            <a :href="commonData.facebook_url">
                                <font-awesome-icon :icon="['fab', 'facebook-square']" />
                            </a>
                        </li>
                    </ul>

                    <template v-if="commonData.categories.length">
                        <h4 class="heading4 heading4--tertiary">
                            Categories
                            <a v-if="false" class="heading-edit"></a>
                        </h4>

                        <div class="tags-list tags-list--light">
                            <span v-for="category in commonData.categories" :key="category.id" class="tags-list__tag" :title="category.name">{{ category.name }}</span>
                        </div>
                    </template>

                    <p v-if="commonData.crunch_status">
                        Data provided by Crunchbase <br>
                        Updated {{ dateHelper.decodeDate(commonData.last_crunchbase_sync_date) }}
                    </p>
                    <p v-else>
                        Data provided by SwitchPitch
                    </p>

                    Data incorrect? <a class="link" @click="$refs.errorReport.open()">Contact us</a>

<!--                    <a class="link" href="#">More</a>-->
                    <template v-if="commonData.website_keywords.length">
                        <div class="accordion mt-4">
                            <header class="accordion__header" v-b-toggle.accordion-1 >
                                <h4 class="accordion__title heading4 heading4--tertiary mb-0">Website Keywords</h4>
                            </header>
                            <b-collapse id="accordion-1" accordion="my-accordion" >
                                <div class="tags-list tags-list--light">
                                      <div v-for="keyword in commonData.website_keywords" :key="keyword" class="tags-list__tag" :title="keyword">
                                         <v-clamp autoresize :max-lines="1">{{ keyword }}</v-clamp>
                                      </div>
                                </div>
                            </b-collapse>
                        </div>
                    </template>
                </div>
            </aside>

            <div class="content">
                <b-tabs class="tabs-primary" content-class="mt-3">
                    <b-tab active>
                        <template #title>
                            Startups
                            <small>{{totalRowsCount}} total</small>
                        </template>

                        <div class="tabs-primary__inner">

                            <template v-if="startups.length">
                                <h2 class="heading2 mb-4">Startups</h2>

                                <div class="main-table">
                                    <Grid
                                        :columns="startupColumns"
                                        :data="startups"
                                        :page-length="parseInt(pageLength)"
                                        :total-rows-count="totalRowsCount"
                                        :sort="sort"
                                        :currentPage="currentPage"
                                        :addCellData="addStartupData"
                                        v-on:changePage="changePage"
                                    >
                                    </Grid>
                                </div>
                            </template>
                        </div>
                    </b-tab>
                    <b-tab class="tab-pane--sticky" :active="showActivityTab">
                        <template #title>
                            Activity
                            <small>{{activities.length}} updates</small>
                        </template>

                        <div class="form-add activity-notes-section">
                            <div class="activity-notes-list">
                                <a @click="interactionType = 'meeting'" class="activity-notes-list__meeting" :class="{active: interactionType == 'meeting'}">Meeting</a>
                                <a @click="interactionType = 'email'" class="activity-notes-list__email" :class="{active: interactionType == 'email'}">Email</a>
                                <a @click="interactionType = 'phone_call'" class="activity-notes-list__call" :class="{active: interactionType == 'phone_call'}">Call</a>
                                <a @click="interactionType = 'note'" class="activity-notes-list__note" :class="{active: interactionType == 'note'}">Note</a>
                            </div>

                            <div class="activity-notes-section__form">
                                <AddNote
                                    v-if="interactionType == 'note'"
                                    companyType="ecosystem"
                                    :companyId="id"
                                    v-on:saved="activitySaved"
                                >
                                </AddNote>

                                <AddInteraction
                                    v-if="['phone_call','email','meeting'].includes(interactionType)"
                                    :type="interactionType"
                                    companyType="ecosystem"
                                    :companyId="id"
                                    :usersMentionList="usersMentionList"
                                    v-on:saved="activitySaved"
                                >
                                </AddInteraction>
                            </div>
                        </div>

                        <div class="accordion accordion--secondary accordion--tabs">
                            <div class="accordion__header-wrapper">
                                <div class="accordion__header" v-b-toggle.collapse-3>
                                    <h4 class="heading4 accordion__title">All Activity</h4>
                                </div>
    
                                <div class="tasks__select" v-click-outside="function() {openInteractionOrderSelect = false}">
                                    <div @click="openInteractionOrderSelect = true" class="tasks__select__chosen">
                                        <span :title="interactionOrderTypes[interactionOrder]">{{interactionOrderTypes[interactionOrder]}}</span>
                                    </div>
                                    <ul v-show="openInteractionOrderSelect" class="multiselect__content">
                                        <li class="multiselect__element" v-for="(name, value) in interactionOrderTypes" :key="value" @click="interactionOrder = value; openInteractionOrderSelect = false; getActivities()">{{name}}</li>
                                    </ul>
                                </div>
                            </div>
                            
                            <b-collapse visible id="collapse-3">
                                <ul class="activity-list">
                                    <li v-for="(activity, index) in activities" :key="index">
                                        <div class="activity-list__author">
                                            <div class="image-block image-block--rounded image-block--rounded--md">
                                                <Avatar
                                                    :username="activity.user_name"
                                                    :src="activity.user_avatar"
                                                >
                                                </Avatar>
                                            </div>
                                            <div>
                                                <h5 class="heading5 heading5--secondary">{{activity.user_name}}</h5>
                                                <time class="activity-list__time">{{dateHelper.decodeDate(activity.date)}}</time>
                                            </div>
                                        </div>
                                        <div class="activity-list__content">
                                            <h5 class="activity-list__title" :class="getActivityIconClass(activity)">{{ activity.title }} <template v-if="activity.interaction_date">({{dateHelper.decodeDate(activity.interaction_date)}})</template></h5>
                                            <div v-html="activity.text" class="text-wrap">

                                            </div>
                                        </div>
                                        
                                        <b-dropdown v-if="true" right class="dropdown-single dropdown-single--big ml-auto pl-5">
                                            <b-dropdown-item v-if="activity.can_edit" @click="editActivity(activity)">
                                                Edit
                                            </b-dropdown-item>
                                            <b-dropdown-item v-if="$store.state.user.is_admin || (activity.type == 'note' && activity.user_id == $store.state.user.id)" @click="removeActivity(activity.log_id)">
                                                Remove
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </li>
                                </ul>
                            </b-collapse>
                        </div>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            Contacts
                            <small>{{contactsTotalCount}} total</small>
                        </template>
                        <div class="tabs-primary__inner">
                            <div class="d-flex align-items-center justify-content-between flex-wrap mb-4">
                                <div class="form-search form-search--mid mb-3 mb-sm-0">
                                    <input type="text" v-model="contactsSearch" placeholder="Search by name or title"/>
                                </div>
                                <a @click="addContact" class="link link--xl">+ Add A Contact</a>
                            </div>
                            
                            <ul class="list-contacts">
                                <li v-for="contact in contacts" :key="contact.id" @click="showContactInfo(contact.id)">
                                    <div class="card card--bordered card--centered" :class="{'card--rated': contact.is_primary}">
                                        <b-dropdown class="drag-n-drop icons-list dropdown-simple dropdown-small position-absolute" boundary="viewport">
                                            <b-dropdown-item v-if="contact.custom && contact.can_edit" class="icons-list__delete" @click.stop="deleteContact(contact.id)">
                                                Delete Contact
                                            </b-dropdown-item>

                                            <b-dropdown-item v-if="!contact.custom" class="icons-list__edit" @click.stop="editContact(contact.id)">
                                                Edit Contact
                                            </b-dropdown-item>
                                        </b-dropdown>
                                        <div class="image-block image-block--rounded--lg">
                                            <Avatar
                                                :username="contact.name"
                                                :src="contact.avatar"
                                                :size="75"
                                            >
                                            </Avatar>
                                        </div>
                                        <h5 class="heading5">{{ contact.name }}</h5>
                                        <p>{{ contact.job_title }}</p>
                                    </div>
                                </li>
                            </ul>

                            <edit-contact
                                ref="editContact"
                                v-on:contactSaved="getContacts"
                            >
                            </edit-contact>
                        </div>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            News
                            <small>{{news.length}} total</small>
                        </template>

                        <div class="tabs-primary__inner">
                            <ul class="list-news">
                                <li v-for="newsItem in news" :key="newsItem.id">
                                    <div class="list-news__date">{{ dateHelper.decodeDate(newsItem.posted_on, ['month-str']) }}</div>
                                    <div>
                                        <h5 class="heading5"><a :href="newsItem.url" target="_blank">{{ newsItem.title }}</a></h5>
                                        {{newsItem.domain}}
                                        <!--<p><time></time></p>-->
                                    </div>
                                </li>
<!--                                <li>-->
<!--                                    <div class="list-news__image">-->
<!--                                        <img src="https://sp-images-prod.s3.amazonaws.com/15446356145c1144de3d456." alt=""/>-->
<!--                                    </div>-->
<!--                                    <div>-->
<!--                                        <h5 class="heading5">Can This Lorem Startup Change The Way We Ipsum?</h5>-->
<!--                                        <p><time>Jan 29, 2020</time></p>-->
<!--                                        <p>Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor-->
<!--                                        euismod, id commodo mi consectetur. Curabitur at vestibulum...</p>-->
<!--                                    </div>-->
<!--                                </li>-->
                            </ul>
                        </div>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            Related
                            <small>{{portfolios.length}} portfolios</small>
                        </template>

                        <div class="tabs-primary__inner">
                            <template v-if="portfolios.length">
                                <h2 class="heading2 mb-4">Shared Portfolios</h2>

                                <table class="main-table">
                                    <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Shared on</th>
                                        <th>Startups</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(portfolio, index) in portfolios" :key="index">
                                        <td>
                                            <router-link :to="'/portfolios/' + portfolio.id">{{portfolio.name}}</router-link>
                                        </td>
                                        <td>
                                            {{dateHelper.decodeDate(portfolio.shared_on)}}
                                        </td>
                                        <td>
                                            {{portfolio.startups_count}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </template>
                        </div>
                    </b-tab>

                </b-tabs>
            </div>
        </main>

        <EditNote
            ref="editNote"
            company-type="ecosystem"
            :company-id="id"
            v-on:saved="activitySaved"
        >
        </EditNote>

        <EditInteraction
            ref="editInteraction"
            v-on:saved="activitySaved"
        >
        </EditInteraction>

        <ErrorReport
            ref="errorReport"
            :ecosystem-id="id"
        >
        </ErrorReport>
    </div>
</template>

<script>

import ecosystems from "@/services/ecosystems.service"
import VClamp from "vue-clamp"
import Avatar from "vue-avatar"
import editContact from "@/components/contacts/EditContact"
import actionLogs from "@/services/action-logs.service"
import Grid from "@/components/Grid";
import grid from "@/mixins/grid";
import tags from "@/services/tags.service";
import EditNote from "@/components/notes/EditNoteModal";
import EditInteraction from "@/components/interactions/EditInteractionModal";
import contacts from "@/services/contacts.service";
import ErrorReport from "@/components/AddErrorReport";
import team from "@/services/team.service";
import AddNote from "@/components/notes/EditNoteInline";
import AddInteraction from "@/components/interactions/EditInteractionInline";

  export default {
      components: {
          VClamp,
          Avatar,
          editContact,
          Grid,
          EditNote,
          EditInteraction,
          ErrorReport,
          AddNote,
          AddInteraction,
      },

      mixins: [grid],

      data() {
          return {
              id: parseInt(this.$route.params.id),
              loaded: false,
              news: [],
              commonData: {},
              contacts: [],
              contactsTotalCount: 0,
              contactsSearch: "",
              activities: [],
              startups: [],
              portfolios: [],
              newNote: "",
              startupColumns: [
                  {
                      label: 'Company',
                      name: 'name',
                      component: 'SearchCompanyNameColumn',
                  },
                  {
                      label: 'Location',
                      name: 'location',
                      component: 'SearchCompanyLocationColumn',
                  }
              ],

              getGridDataMethodName: 'getStartupsList',

              addStartupData: {
                  companyType: "startups",
                  tagsList: [],
              },

              interactionOrder: 'created_at',
              openInteractionOrderSelect: false,
              interactionOrderTypes: {
                  'created_at': 'Date added',
                  'interaction_date': 'Interaction date',
              },

              showActivityTab: false,
              usersMentionList: [],
              mentionApplied: false,

              interactionType: 'meeting',
          }
      },

      mounted() {
          if (this.$route.query.activity) {
              this.showActivityTab = true
          }

          this.getData()
          this.updateList()
          this.getTagsList()

          this.getUsersMentionList()
      },

      watch: {
          contactsSearch() {
              this.getContacts()
          }
      },

      computed: {
          logoUrl() {
              if (this.commonData.logo_url) {
                  return this.commonData.logo_url
              }
              else {
                  return require('@/images/' + this.defaults.startupLogo)
              }
          },

          location() {
              let str = []

              if (this.commonData.city) {
                  str.push(this.commonData.city)
              }

              if (this.commonData.state) {
                  str.push(this.commonData.state)
              }

              if (this.commonData.country) {
                  str.push(this.commonData.country)
              }

              if (this.commonData.continent) {
                  str.push(this.commonData.continent)
              }

              return str.join(', ')
          },
      },

      methods: {
          getData() {
              ecosystems.getCommonData(this.id).then(response => {
                  this.commonData = response.data
                  document.title = this.commonData.name + ' | SwitchPitch'
                  this.fundingRounds = this.commonData.funding_rounds
                  this.loaded = true
              })

              ecosystems.getNews(this.id).then(response => {
                  this.news = response.data
              })

              ecosystems.getSharedPorfolios(this.id).then(response => {
                  this.portfolios = response.data
              })

              this.getContacts()
              this.getActivities()
          },

          getStartupsList() {
              let columns = this.arrayHelper.arrayColumn(this.startupColumns, 'name')
              let currentPage = this.currentPage
              let pageLength = this.pageLength

              ecosystems.getStartups(this.id, {columns, currentPage, pageLength}).then(response => {
                  this.startups = response.data.data
                  this.totalRowsCount = parseInt(response.data.total_count)
                  this.currentPage = response.data.current_page
              })
          },

          getTagsList() {
              tags.getList().then(response => {
                  this.addStartupData.tagsList = response.data
              })
          },

          getContacts() {
              ecosystems.getContacts(this.id, this.contactsSearch).then(response => {
                  this.contacts = response.data

                  if (!this.contactsSearch.length) {
                      this.contactsTotalCount = this.contacts.length
                  }
              })
          },

          getActivities() {
              ecosystems.getActivities(this.id, this.interactionOrder).then(response => {
                  this.activities = response.data
              })
          },

          closeDescriptionPopover() {
              this.$refs.descriptionPopover.$emit('close')
          },

          showContactInfo(id) {
              this.$refs.editContact.open(id)
          },

          addContact() {
              this.$refs.editContact.open(0, 0, this.id)
          },

          getActivityIconClass(activity) {
              if (activity.type == 'note') {
                  return 'activity-list__title--note'
              }
              else if (activity.type == 'phone_call') {
                  return 'activity-list__title--call'
              }
              else if (activity.type == 'email') {
                  return 'activity-list__title--email'
              }
              else if (activity.type == 'meeting') {
                  return 'activity-list__title--meeting'
              }
              else {
                  return ''
              }
          },

          addNote() {
              if (this.mentionApplied) {
                  this.$nextTick(() => {
                      this.mentionApplied = false
                  })
              }
              else if (this.newNote.length) {
                  ecosystems.saveNote(this.id, 0, {text: this.newNote}).then(() => {
                      this.activitySaved()
                  })
              }
          },

          addInteraction() {
              this.$refs.editInteraction.open(0, 'ecosystem', this.id, this.newNote)
          },

          removeActivity(logId) {
              if (confirm("Remove activity?")) {
                  actionLogs.removeActivity(logId).then(() => {
                      this.getActivities()
                  })
              }
          },

          editActivity(activity) {
              if (activity.object_type == 'ecosystem-note') {
                  this.$refs.editNote.open(activity.object_id)
              }

              else if (activity.object_type == 'interaction') {
                  this.$refs.editInteraction.open(activity.object_id)
              }
          },

          activitySaved() {
              this.getActivities()
          },

          deleteContact(id) {
              if (confirm("Delete contact?")) {
                  contacts.delete(id).then(() => {
                      this.getContacts()
                  })
              }
          },

          editContact(id) {
              this.$refs.editContact.open(id, 0, 0, true)
          },

          getUsersMentionList() {
              team.getUsersMentionList().then(response => {
                  this.usersMentionList = response.data
              })
          }
      }
  }
</script>

<style scoped>

</style>